{
  "name": "tech-architecture-front",
  "version": "1.0.0",
  "scripts": {
    "ng": "ng",
    "preinstall": "npx only-allow pnpm",
    "start": "ng serve --port=4200 -o",
    "start:dev": "ng serve --port=4200 -o --configuration=development",
    "start:test": "ng serve --port=4200 -o --configuration=testing",
    "start:prod": "ng serve --port=4200 -o --configuration=production",
    "build:prod": "cp src/app/shared/services/wasm/pkg/file_processor_bg.wasm . && ng build --configuration=production",
    "build:test": "cp src/app/shared/services/wasm/pkg/file_processor_bg.wasm . && ng build --configuration=testing",
    "build:dev": "cp src/app/shared/services/wasm/pkg/file_processor_bg.wasm . && ng build --configuration=development",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "tech:components": "pnpm i @tech/components --registry https://npm2.techtitute.com",
    "tech:protocol": "pnpm i @tech/intranet-core-protocol --registry https://npm2.techtitute.com",
    "tech:clients": "pnpm i @tech/api-clients --registry https://npm2.techtitute.com"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^17.3.12",
    "@angular/cdk": "^17.3.10",
    "@angular/common": "^17.3.12",
    "@angular/compiler": "^17.3.12",
    "@angular/core": "^17.3.12",
    "@angular/forms": "^17.3.12",
    "@angular/material": "~17.3.10",
    "@angular/platform-browser": "^17.3.12",
    "@angular/platform-browser-dynamic": "^17.3.12",
    "@angular/router": "^17.3.12",
    "@fontsource/roboto": "^5.2.8",
    "@ngrx/effects": "^17.2.0",
    "@ngrx/router-store": "^17.2.0",
    "@ngrx/store": "^17.2.0",
    "@ngrx/store-devtools": "^17.2.0",
    "@ngx-translate/core": "^15.0.0",
    "@tech/api-clients": "^1.7.75",
    "@tech/components": "^4.0.35",
    "@tech/intranet-core-protocol": "^4.0.19",
    "emscripten-sdk-npm": "^0.3.2",
    "keycloak-angular": "^16.1.0",
    "keycloak-js": "^26.2.4",
    "material-symbols": "^0.31.9",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "vite-plugin-wasm": "^3.5.0",
    "wasm-pack": "^0.13.1",
    "zone.js": "^0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^17.3.17",
    "@angular/cli": "~17.3.17",
    "@angular/compiler-cli": "^17.3.12",
    "@angular/language-service": "^17.3.12",
    "@types/jasmine": "~4.3.6",
    "jasmine-core": "^5.12.1",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.4.5"
  }
}
